import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { alpha, Stack, Typography } from '@mui/material';

interface DashboardQuantifyChartFooterProps {
  isTableView: boolean;
}

export const DashboardQuantifyChartFooter = ({
  isTableView,
}: DashboardQuantifyChartFooterProps) => {
  const traverseCount = useQuantifyStore(
    ({ visual }) => visual.timeRangeTraversal.traverseCount,
  );

  if (isTableView || !traverseCount) {
    return null;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      py={1}
      px={3}
      spacing={1}
      sx={{
        backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.05),
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <InfoOutlined color="warning" fontSize="small" />
      <Typography variant="caption" color="text.disabled">
        This change to time-range won't be saved to the Quantify
      </Typography>
    </Stack>
  );
};
